import { DRAWER_KEY } from 'app-constants'
import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import './style.scss'

export function EmptyOffer() {
  const dispatch = useDispatch()

  function handleClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='empty-offer-container'>
      <STATICS.INFO_OUTLINE className='icon' />
      <div className='empty-offer-content'>
        <h3 className='title'>Ops! No momento, não existem novas ofertas disponíveis.</h3>
        <p className='info'>Em breve você poderá conferir novas oportunidades.</p>
      </div>
      <Button onClick={handleClose} className='confirm-button' color='primary' size='large'>
        ok, entendi!
      </Button>
    </div>
  )
}
